import React from "react";
import Loader from "../../components/common/Loader";
import Header from "../../components/innerpage/about/Header";
import Navbar from "../../components/home1/Navbar";
import About from "../../components/innerpage/about/About";
import Process from "../../components/innerpage/about/Process";
import Projects from "../../components/innerpage/about/Projects";
// import Awards from "../../components/innerpage/about/Awards";
import Footer from "../../components/home1/Footer";
import Menu from "../../components/innerpage/Menu";
import { Helmet } from "react-helmet";
import { SITE_URL, SITE_NAME, DEFAULT_OG_IMAGE } from "../../seoConfig";

const PAGE_TITLE = "About Us | " + SITE_NAME;
const PAGE_DESC =
  "Learn about our architecture and interior design studio — our story, our design philosophy, and the team behind spaces that combine creativity, functionality, and craftsmanship.";
const PAGE_PATH = "/innerpages/about";

function AboutPage() {
  return (
    <>
      <Helmet>
        <title>{PAGE_TITLE}</title>
        <meta name="description" content={PAGE_DESC} />
        <link rel="canonical" href={`${SITE_URL}${PAGE_PATH}`} />
        <meta property="og:type" content="website" />
        <meta property="og:title" content={PAGE_TITLE} />
        <meta property="og:description" content={PAGE_DESC} />
        <meta property="og:url" content={`${SITE_URL}${PAGE_PATH}`} />
        <meta property="og:image" content={`${SITE_URL}${DEFAULT_OG_IMAGE}`} />
        <meta property="og:site_name" content={SITE_NAME} />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={PAGE_TITLE} />
        <meta name="twitter:description" content={PAGE_DESC} />
        <link
          rel="stylesheet"
          type="text/css"
          href="/innerpages/assets/css/innerpages.css"
        />

        <link
          rel="stylesheet"
          type="text/css"
          href="/innerpages/assets/css/navbar-fix.css"
        />

        <script src="/common/assets/js/common_js.js"></script>
        <script src="/innerpages/assets/js/innerpages.js"></script>
      </Helmet>
      {/* <body className="inner-pages-style1 about-pg-style1"> */}
      <body className="home-style1 inner-pages-style1 about-pg-style1">
        <Loader />
        <Menu />
        <div className="smooth-scroll-content" id="scrollsmoother-container">
          <Navbar />
          <Header />
          <main>
            <About />
            <Process />
            <Projects />
            {/* <Awards /> */}
          </main>
          <Footer />
        </div>
      </body>
    </>
  );
}

export default AboutPage;
